import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import FormComponent from "../../../components/commonComponent/QuestionnareForm";
import { FIELDS } from "../../../constants/SiteConstants";
import useModal from "../../../hooks/useModal";
import SpecificViewModal from "../../../components/commonComponent/SpecificViewModal";
import useFetchUserOptions from "../../../hooks/useFetchUserOptions";

const API_URL = process.env.REACT_APP_API_URL;

const EditQuestion = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [answers, setAnswers] = useState([]);
  const users = useFetchUserOptions(true);
  const {
    showViewModal,
    selectedItem,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();

  useEffect(() => {
    fetchQuestionById();
    fetchAnswersById();
  }, [id]);

  const fetchQuestionById = async () => {
    try {
      const res = await axios.get(`${API_URL}/questions/getQuestionById/${id}`);
      setTitle(res?.data?.data?.title);
      setDescription(res.data.data?.description);
    } catch (error) {
      toast.error("Failed to load question data", { autoClose: 1000 });
    }
  };

  const fetchAnswersById = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/answers/getAnswerByQuestionId/${id}`
      );
      setAnswers(res?.data?.data);
    } catch (err) {
      toast.error("Failed to load answers", { autoClose: 1000 });
    }
  };

  const handleUpdateQuestion = () => {
    let formErrors = {};

    if (!title.trim()) {
      formErrors.title = "Title is required";
    }
    if (!description.trim() || description === "<p><br></p>") {
      formErrors.description = "Description is required";
    }
    if (Object.keys(formErrors).length > 0) {
      for (const key in formErrors) {
        toast.error(formErrors[key], { autoClose: 1000 });
      }
      return;
    }
    const updatedQuestion = {
      title,
      description,
    };

    axios
      .put(`${API_URL}/questions/updateQuestionById/${id}`, updatedQuestion)
      .then(() => {
        toast.success("Question updated successfully", { autoClose: 1000 });
        navigate("/questions");
      })
      .catch((error) => {
        toast.error("Failed to update question", { autoClose: 1000 });
      });
  };

  const columns = [FIELDS.USERNAME, FIELDS.ANSWERS];
  const data = answers?.map((ans) => {
    return {
      answerId: ans._id,
      Username: ans.userId ? ans.userId.fullName : "Unknown User",
      Answer: ans.answerDescription,
    };
  });

  return (
    <>
      <div className="form-wrapper shadow-md">
        <div className="form-header">
          <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
            Update Q&A
          </h3>
          <button
            className="form-close-btn"
            onClick={() => navigate("/questions")}
          >
            &times;
          </button>
        </div>
        <FormComponent
          title={title}
          description={description}
          setTitle={setTitle}
          setDescription={setDescription}
          isEditMode={true}
          columns={columns}
          data={data}
          users={users}
          onViewAnswer={handleOpenViewModal}
        />

        <button
          className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
          onClick={handleUpdateQuestion}
        >
          Update Question
        </button>
      </div>

      <SpecificViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={answers}
      />
    </>
  );
};

export default EditQuestion;
